import { Themes } from '@/features/theming/ui/Themes';

/**
 * §5: a page composes, it does not implement.
 */
export function ThemesPage() {
  return <Themes />;
}
